module.exports = __webpack_public_path__ + "img/rca_leaf_logo.d06221f2.svg";